import React from "react";
import { Radiobutton } from "../../../view/Radiobutton";

function TargetTypeRadiobuttonElement({ element, index, onClick, disabled }) {

    return (
        <li className="addrules-target-item-v2" key={index}>
            <Radiobutton checked={element.selected}
                onClick={disabled ? null : () => onClick(element)}
                disabled={disabled} />
            <span>{element.name}</span>

            {/* <input className="radio-button"
                    type="radio"
                    name="radioGroup"
                    value={index}
                    checked={element.selected}
                    onChange={disabled ? null : () => onClick(element)}
                    disabled={disabled}
            />
          <label>{element.name}</label> */}
            {/* <span>{element.name}</span> */}
        </li>
    )
}

export default TargetTypeRadiobuttonElement;
